import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    value: [],
};
export const popupSlice = createSlice({
    name: "popup",
    initialState: initialState,
    reducers: {
        showPopup: (state, action) => {
            state.value = [...state.value, {
                state: true,
                msg: action.payload.msg ? action.payload.msg : "",
                btnText: action.payload.btnText ? action.payload.btnText : "확인",
                btn2Text: action.payload.btn2Text ? action.payload.btn2Text : undefined,
                onClickBtn: action.payload.onClickBtn ? action.payload.onClickBtn : () => {},
                onClickBtn2: action.payload.onClickBtn2 ? action.payload.onClickBtn2 : () => {},
                backdrop: action.payload.backdrop ? action.payload.backdrop : undefined
            }];
        },
        hidePopup: (state, action) => {
            state.value[action.payload].state = false;
        },
    }
})

export const {showPopup, hidePopup} = popupSlice.actions;
export default popupSlice.reducer;